import React from 'react';
interface SectionHeadingProps {
  title: string;
  intro?: string;
  tone?: 'light' | 'dark';
  align?: 'left' | 'center';
}
export function SectionHeading({
  title,
  intro,
  tone = 'light',
  align = 'left'
}: SectionHeadingProps) {
  const isDark = tone === 'dark';
  return <div className={align === 'center' ? 'mx-auto max-w-2xl text-center' : 'max-w-3xl'} data-id="element-87" data-mp="3jzx4bzvre8pe">
      <div className={`h-px w-12 bg-gold-500 ${align === 'center' ? 'mx-auto' : ''}`} aria-hidden="true" data-id="element-88" data-mp="bkdfdd24fcg5" />
      <h2 className={`mt-6 font-display text-3xl font-semibold leading-tight tracking-tight sm:text-4xl ${isDark ? 'text-white' : 'text-navy-900'}`} data-id="element-89" data-mp="gjq11uh9adh5">
        {title}
      </h2>
      {intro ? <p className={`mt-4 text-base leading-relaxed ${isDark ? 'text-white/70' : 'text-muted'}`} data-id="element-90" data-mp="6s2ea6vn9km0">
          {intro}
        </p> : null}
    </div>;
}